(function () {
    'use strict';

    var CONTENT_TYPE = 'department';

    angular.module('swif.openbase')
        .config(route)
        .factory('swifOpenbaseDepartmentService', swifOpenbaseDepartmentService)
        .controller('DepartmentsController', DepartmentsController)
        .controller('DepartmentsOrganizationController', DepartmentsOrganizationController)
        .controller('DepartmentController', DepartmentController)
        .controller('DepartmentMailgateController', DepartmentMailgateController)
        .directive('panelDepartment', panelDepartment);


    function route($routeProvider) {
        $routeProvider.when('/configuration/departments/table_view', {
            templateUrl: 'partials/openbase/departments_table_view.html',
            controller: 'DepartmentsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/departments/organization_view', {
            templateUrl: 'partials/openbase/departments_organization_view.html',
            controller: 'DepartmentsOrganizationController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseDepartmentService
     * @description manage department
     * @requires swif.framework.swifFrameworkService
     * @requires swif.openbase.swifOpenbaseUserService
     **/
    function swifOpenbaseDepartmentService(swif, swifOpenbaseUserService) {
        'ngInject';
        var openbaseUserService = swifOpenbaseUserService;
        var service = {};
        service.createCollection = function () {
            var filter = {};
            filter.fields = [
                'id',
                'name',
                'active',
                'actions',
                'manager_id',
                'service_id',
                'technical',
                'fetchmail_ids',
                'entity_id'
            ];
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('departments', 'department', filter, {location: true})
            .then(function (collection) {
                return collection;
            });
        };
        service.createCollectionUsers = function (service_id) {
            var userFilter = {};
            swif.data.addExtraFilter(userFilter, 'inDepartment', 'service_id.id', '=', service_id);
            return swif.collections.createOrUpdate(
                'departmentUsers', 'user', userFilter
            );
        };
        service.getCollection = function () {
            return swif.collections.getCollection('departments');
        };
        service.getCollectionUsers = function () {
            return swif.collections.getCollection('departmentUsers');
        };
        service.preModal = function (data) {
            swif.collections.getCollection('departments').preModal(data);
            if (data.action.id === 'edit') {
                var params = {fields: ['partner_id']};
                if (swif.module.modules.openstc || swif.module.modules.opengst_public_lightning) {
                    params.fields = _.union(params.fields, [
                        'technical',
                        'is_assignable_to_ask',
                        'is_assignable_to_project',
                        'is_assignable_to_task',
                        'allows_ask_on_maintained_equipment',
                        'technical_service_id',
                        'technical_service_ids',
                        'technical_site_id',
                        'technical_site_ids'
                    ]);
                }
                if (swif.module.modules.opengst_parcauto) {
                    params.fields = _.union(params.fields, [
                        'is_parcauto'
                    ]);
                }
                if (swif.module.modules.opengst_public_lightning) {
                    params.fields = _.union(params.fields, [
                        'is_public_lightning'
                    ]);
                }
                if (swif.module.modules.openstc_patrimoine) {
                    params.fields = _.union(params.fields, [
                        'is_assignable_to_patrimoine_contract'
                    ]);
                }
                if (!_.isEmpty(params.fields)) {
                    swif.data.get('department', data.model.id, params)
                    .then(function (item) {
                        swif.data.updateObj(item, data.model);
                    });
                }
            }
        };
        service.preValidate = function (data) {
            var ret = true;
            var collection = service.getCollection();
            if (collection) {
                ret = collection.preValidate(data);
            }
            if (data.action.id === 'add' || data.action.id === 'edit') {
                //replace many2one of partner
                data.model.technical_service_ids = data.model._technical_service_ids;
                data.model.technical_site_ids = data.model._technical_site_ids;
                return swif.data.sanitizeData('partner', data.model, [
                    'technical_service_id',
                    'technical_service_ids',
                    'technical_site_id',
                    'technical_site_ids'
                ]).then(function (partner) {
                    swif.data.updateObj(partner, data.model);
                    return ret;
                });
            } else if(data.action.id === 'manage_mailgate') {
                // first, save existing servers updated
                _.forEach(data.model._mailgates, function (mailgate) {
                    if(!mailgate._active ||
                        mailgate.user &&
                        mailgate.password &&
                        mailgate.server &&
                        mailgate.type &&
                        mailgate.port &&
                        mailgate.object_id
                    ) {
                        var deferred;
                        // ensure newly created entries to have a name
                        mailgate.name = '';
                        mailgate.name += mailgate.user || '';
                        mailgate.name += mailgate.server ? ': ' + mailgate.server : '';
                        mailgate.name += '(' + mailgate.object_id[1]  + ')';

                        // save / update the mailgate server
                        // (according to presence, or not, of ID)
                        if(mailgate.id) {
                            deferred = swif.data.save(
                                'mailgate_server',
                                mailgate.id,
                                mailgate
                            );
                        } else {
                            deferred = swif.data.create(
                                'mailgate_server',
                                mailgate
                            );
                        }
                        // then, configure the department addresses to ensure
                        // a mail exists to wrap the new fetchmail entry
                        deferred.then(function (ret) {
                            // attach the ID for newly created entry
                            // ret is an ID only after a create()
                            if(!mailgate.id) {
                                mailgate.id = ret.result;
                            }

                            // finally:
                            // - set-up the 'activated' mailgate servers
                            // - set to draft the 'deactivated' mailgate servers
                            if(mailgate._active) {
                                swif.data.callKw(
                                    'mailgate_server',
                                    'button_confirm_login',
                                    [[mailgate.id]]
                                );
                            } else {
                                swif.data.callKw(
                                    'mailgate_server',
                                    'set_draft',
                                    [[mailgate.id]]
                                );
                            }
                        });
                    }
                });
                // then, create the (optionaly) new server entry
                /* var newV = data.model._new_mailgate;
                if(newV.user && newV.password) {
                    swif.data.create('mailgate_server', newV);
                }; */
            }
            return ret;
        };
        service.preValidateUser = function (data) {
            return openbaseUserService.preValidate(data, 'departmentUsers');
        };
        service.callback = function (error, data) {
            var collection = service.getCollection();
            collection.defaultActionCallback(error, data);
        };
        service.callbackUser = function (error, data) {
            var collection = service.getCollectionUsers();
            collection.defaultActionCallback(error, data);
        };
        service.preModalUser = function (data) {
            var service_id = [data.model.id, data.model.name];      
            swifOpenbaseUserService.preModal(data, 'departmentUsers');
            if (data.action.id === 'add') {
                data.model.service_id = service_id;
                data.model._is_member = true;
            }
        };
        return service;
    }

    function DepartmentsController($scope, swif, swifOpenbaseDepartmentService, swifOpenbaseUserService) {
        'ngInject';
        var departmentService = swifOpenbaseDepartmentService;
        swifOpenbaseUserService.initialize();

        departmentService.createCollection().then(function (collection) {
            $scope.departments = collection;
        });
        $scope.modules = swif.module.modules;
        $scope.preModal = departmentService.preModal;
        $scope.preValidate = departmentService.preValidate;
        $scope.callback = departmentService.callback;
        $scope.preModalUser = departmentService.preModalUser;
        $scope.preValidateUser = departmentService.preValidateUser;
        $scope.callbackUser = departmentService.callbackUser;
        $scope.$watch('departments.currentItem.id', function (newV) {
            if (newV) {
                departmentService.createCollectionUsers(newV)
                .then(function (collection) {
                    $scope.users = collection;
                });
            }
        });
    }

    function DepartmentsOrganizationController($scope, swif) {
        'ngInject';
        $scope.modules = swif.module.modules;
        var filter = {};
        swif.data.sortOn(filter, 'name', 'ASC');

        swif.collections.createOrUpdate(
            'departments',
            CONTENT_TYPE,
            filter,
            {limitPerPage: 50}
        ).then(function (collection) {
            $scope.departments = collection;
        });

        $scope.vocabulariesConfiguration = {
            user: true,
            department: true
        };
    }


    function DepartmentController($scope, swif) {
        'ngInject';
        console.log('init DepartmentController');
        $scope.modules = swif.module.modules;
        $scope.filters = {
            manager: {},
            service_id: {},
            technical_service_id: {},
            technical_service_ids: {},
            technical_site_id: {},
            technical_site_ids: {}
        };
        swif.data.addFilter($scope.filters.technical_service_id, 'is_assignable_to_ask', '=', true);
        swif.data.addFilter($scope.filters.technical_service_ids, 'is_assignable_to_ask', '=', true);
        var getDepartmentsFilter = function () {
            var ret = {};
            swif.data.addFilter(ret, 'is_assignable_to_ask', '=', true);
            if (!_.isEmpty($scope.model._technical_service_ids)) {
                swif.data.addFilter(ret, 'id', 'in', $scope.model._technical_service_ids);
            }
            return ret;
        };
        var getSitesFilter = function () {
            var ret = {};
            if (!_.isEmpty($scope.model._technical_site_ids)) {
                swif.data.addFilter(ret, 'id', 'child_of', $scope.model._technical_site_ids);
            }
            return ret;
        };
        $scope.$watchGroup(
            ['model._technical_service_ids', 'model._technical_site_ids'],
            function (newV, oldV) {
                if (!angular.equals(newV, oldV)) {
                    $scope.filters.technical_service_id = getDepartmentsFilter();
                    $scope.filters.technical_site_id = getSitesFilter();
                }
            }
        );

        swif.data.addFilter($scope.filters.department, 'is_assignable_to_ask', '=', true);
        if ($scope.model.id) {
            swif.data.addFilter($scope.filters.manager, 'service_ids', 'in', [$scope.model.id]);
            swif.data.addFilter($scope.filters.service_id, 'id', '!=', $scope.model.id);
        }
        $scope.$watch('model.partner_id', function (newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                swif.data.get('partner', newV[0])
                .then(function (partner) {
                    if (partner) {
                        $scope.partner = partner;
                        $scope.model.technical_service_id = partner.technical_service_id;
                        $scope.model._technical_service_ids = partner.technical_service_ids;
                        $scope.model.technical_site_id = partner.technical_site_id;
                        $scope.model._technical_site_ids = partner.technical_site_ids;
                    }
                });
            }
        });
    }

    function DepartmentMailgateController($scope, swif) {
        'ngInject';
        console.log('init DepartmentMailgateController');

        // first, parse the configuration.json to see if default values are filled
        var fetchmail_settings = swif.settings.app.fetchmail_server || {};
        // prepare item to compute some internal attributes,
        // and to ensure a maximum of required data has a default value
        // new entries are 'active' by default
        // BE CAREFUL: object_id is required, but has not yet any default value
        $scope._prepare_mailgate = function (item) {
            item.service_id = [$scope.model.id, $scope.model.name];
            item._active = item.state !== 'draft';
            item.server = item.server || fetchmail_settings.server;
            item.type = item.type || fetchmail_settings.type;
            item.port = item.port || fetchmail_settings.port;
            item.is_ssl = item.is_ssl || fetchmail_settings.is_ssl;
            item._type= 'mailgate_server';
        };

        $scope.check_connection = function (mailgate) {
            mailgate._status_validation = '';
            mailgate._checking = true;
            swif.data.callKw('mailgate_server', 'check_connection', [mailgate])
            .then(function (ret) {
                mailgate._status = ret;
                mailgate._checking = false;
                mailgate._status_validation = ret.connection_status ? 'OK' : '';
            });
        };

        $scope.fetch_robots_and_mailgates = function () {
            // create mailgates with an empty one, to allow user to create new record
            var default_record = {};
            $scope._prepare_mailgate(default_record);
            $scope.model._mailgates = [default_record];
            var filter = {};
            swif.data.addFilter(
                filter,
                'service_id',
                '=',
                $scope.model.id
            );
            swif.data.get('mailgate_server', undefined, filter)
            .then(function (server_data) {
                if(server_data.length > 0) {
                    /* @tocheck: should we allow to create
                    a record if some others are already set ?
                     var mailgates = _.union(
                        server_data,
                        $scope.model._mailgates
                    ); */
                    var mailgates = server_data;
                    _.forEach(mailgates, function (item) {
                        $scope._prepare_mailgate(item);
                    });
                    $scope.model._mailgates = mailgates;
                }
            });
            // @TODO: handle the case when a department has no partner (data issue)
        };
        var objectFilter = {};
        swif.data.addFilter(objectFilter, 'name', 'in', ['openstc.ask']);
        $scope.objectFilter = objectFilter;
        $scope.modules = swif.settings.app.modules;
        $scope.fetch_robots_and_mailgates();
    }

    function panelDepartment(swifPanelService) {
        'ngInject';
        var directive = swifPanelService.create_directive('department');
        directive.templateUrl = 'partials/openbase/panel-department.html';
        return directive;
    }


})();
